
<template>
  <div class="solve">
    <div class="banner">
      <img src="@/assets/solve/solveSolution.png">
    </div>
    <div class="text">
      <div class="inner">
        <p>解决方案</p>
        <p>&mdash;&nbsp;Solution&nbsp;&mdash;</p>
      </div>
    </div>
    <div class="settle">
      <div class="inner">
        <ul class="settleCon settleLeft">
          <li>
            <p>设备管理类</p>
            <p>device management</p>
          </li>
          <li>
            <p>设备管理类</p>
            <p>device management</p>
          </li>
          <li>
            <p>设备管理类</p>
            <p>device management</p>
          </li>
        </ul>
        <img src="@/assets/solve/solveRamme.png" alt="">
        <ul class="settleCon settleRight">
          <li>
            <p>输出管理类</p>
            <p>output management</p>
          </li>
          <li>
            <p>输出管理类</p>
            <p>output management</p>
          </li>
          <li>
            <p>输出管理类</p>
            <p>output management</p>
          </li>
        </ul>
      </div>
    </div>
    <div class="task">
      <div class="taskTop">
        <p>任务管理类</p>
        <p></p>
        <p>任务管理类解决方案，资料待完善......</p>
      </div>
      <ul class="taskBoot inner">
        <li v-for="item in taskBootPicList" :key="item.id">
          <!-- <img :src="item.url" alt=""> -->
          <div class="solvePic"></div>
          <p>{{item.tit}}</p>
          <p>{{item.content}}</p>
        </li>
      </ul>
    </div>
    <div class="more"> <a href="">查看更多</a></div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import '@/css/solve.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
export default {
  components: {
    footerPage,
  },
  data() {
    return {
      taskBootPicList: [
        {
          id: 1, url: require("@/assets/solve/solvePdf.png"), tit: '-20120831114707-东芝数码 复合机及决方案DMIII.wps', content: '-2012083114707- Toshiba digital composite machine and Its Solutions DMIII.wps'
        },
        {
          id: 2, url: require("@/assets/solve/solvePdf.png"), tit: '-20120831114707-东芝数码 复合机及决方案DMIII.wps', content: '-2012083114707- Toshiba digital composite machine and Its Solutions DMIII.wps'
        },
        {
          id: 3, url: require("@/assets/solve/solvePdf.png"), tit: '-20120831114707-东芝数码 复合机及决方案DMIII.wps', content: '-2012083114707- Toshiba digital composite machine and Its Solutions DMIII.wps'
        },
        {
          id: 4, url: require("@/assets/solve/solvePdf.png"), tit: '-20120831114707-东芝数码 复合机及决方案DMIII.wps', content: '-2012083114707- Toshiba digital composite machine and Its Solutions DMIII.wps'
        },
        {
          id: 5, url: require("@/assets/solve/solvePdf.png"), tit: '-20120831114707-东芝数码 复合机及决方案DMIII.wps', content: '-2012083114707- Toshiba digital composite machine and Its Solutions DMIII.wps'
        },
        {
          id: 6, url: require("@/assets/solve/solvePdf.png"), tit: '-20120831114707-东芝数码 复合机及决方案DMIII.wps', content: '-2012083114707- Toshiba digital composite machine and Its Solutions DMIII.wps'
        },
      ],
    }
  },
  methods: {
  }
}
</script>

<style>
</style>